import { render, staticRenderFns } from "./bindPhoneNum.vue?vue&type=template&id=325bc572&scoped=true&"
import script from "./bindPhoneNum.vue?vue&type=script&lang=js&"
export * from "./bindPhoneNum.vue?vue&type=script&lang=js&"
import style0 from "./bindPhoneNum.vue?vue&type=style&index=0&id=325bc572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325bc572",
  null
  
)

export default component.exports